export class Dictionary {
  id: any;
  title: string;
}

// TODO: Is this Lookup?
